import { render, staticRenderFns } from "./DetachEmployeeAccessDialog.vue?vue&type=template&id=376a4cb5&scoped=true"
import script from "./DetachEmployeeAccessDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DetachEmployeeAccessDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetachEmployeeAccessDialog.vue?vue&type=style&index=0&id=376a4cb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a4cb5",
  null
  
)

export default component.exports